import router from '@/router'
import axios from 'axios'
import Vue from 'vue'
import {Message} from 'element-ui'
import {otherCode} from "@/utils/otherCode";
// Vue.prototype.$messageUi = Message
import {getDataInLocalStorage, removeDataInLocalStorage} from '@/utils/localStorageUtils'
import {reject} from "eslint-plugin-promise/rules/lib/promise-statics";

axios.defaults.headers['Content-Type'] = 'application/json'
// axios.defaults.baseURL = 'api/';
// axios.defaults.baseURL = 'http://127.0.0.1:50088/';
axios.defaults.baseURL = process.env.VUE_APP_BASE_API;
// http request拦截器 添加一个请求拦截器
var that = this
axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  let token = getDataInLocalStorage("token")
  if (token) {
    // config.headers['token'] = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzM4NCJ9.eyJleHAiOjE2Nzk4MjI1NjEsImlhdCI6MTY3NzIzMDU2MSwicm9sZSI6Im1hbmFnZXIiLCJpZCI6NDc0MTk3NTg5NDU3Mn0.uCZblcHC9xBNdSPywjrtJo1cvaH3NsvqLy0GhyPye0K9W-bjtHT0_wxMFJVKJ8XV" //过期的token
    config.headers['token'] = token //将token放到请求头发送给服务器
  }
  return config;
});
axios.interceptors.response.use(response => {
    var state = response.data.code
    if (state) {
      if (state !== 200) {
        if(!otherCode.hasOwnProperty(state)){
          Message({message: response.data.message, type: 'error'})
          return ;
        }
      }
    }
    var conDis = response.headers['content-disposition']
    var cap = response.headers.captchasing//图形验证
    const regex = /filename=(.+\.[a-zA-Z]+)/
    if (conDis && regex.test(conDis)) {
      let data = {
        file: response.data,
        fileName: regex.exec(conDis)[1]
      }
      return data;
    }
    if (cap) {
      let data = {
        CaptchaSing: cap,
        imgUrl: response.data
      }
      return data;
    }
    return response.data;
  },
  error => {
    let{message}  = error;
    if (message === "Request failed with status code 401") {
     removeDataInLocalStorage("token");
      router.push("/login");
    } else if (message === "Request failed with status code 500") {
      Message.error('服务器后端异常，请稍后重试')
      return Promise.reject(new Error('服务器后端异常，请稍后重试'))
    } else {
      Message.error('网站异常，请稍后重试')
      return;
      return Promise.reject(new Error('网站异常，请稍后重试'))
    }
  }
)
